import { z } from 'zod';

export const envSchema = z.object({
  VITE_APP_NAME: z.string().min(1).default('lwart-gestao-abastecimento'),
  VITE_APP_ENV: z.enum(['dev', 'alfa', 'beta', 'prod']),
  VITE_API_BASE_URL: z
    .string()
    .min(1)
    .refine(
      (val) => {
        try {
          // Aceita URLs completas ou paths relativos começando com /
          if (val.startsWith('/')) return true;
          new URL(val);
          return true;
        } catch {
          return false;
        }
      },
      { message: 'Invalid URL' },
    ),
  VITE_API_TIMEOUT_MS: z.coerce.number().int().positive().default(15000),
  VITE_LOG_LEVEL: z.enum(['debug', 'info', 'warn', 'error']).default('info'),
});

export type AppEnv = z.infer<typeof envSchema>;

export type RawEnv = Readonly<Record<string, string | undefined>>;

export function validateEnv(raw: RawEnv): AppEnv {
  const parsed = envSchema.safeParse(raw);

  if (!parsed.success) {
    const issues = parsed.error.issues
      .map((issue) => {
        const pathStr = issue.path.length > 0 ? issue.path.join('.') : '<root>';
        return `${pathStr}: ${issue.message}`;
      })
      .join('; ');
    throw new Error(`[env] configuração de ambiente inválida — ${issues}`);
  }

  return parsed.data;
}

let cachedEnv: AppEnv | null = null;

export function getEnv(): AppEnv {
  cachedEnv ??= validateEnv(import.meta.env as unknown as RawEnv);
  return cachedEnv;
}

export function __resetEnvCache(): void {
  cachedEnv = null;
}
